// Suppress benign ResizeObserver loop error (e.g. from react-resize-detector when
// many comment elements mount). Notifications are deferred, not lost.
window.addEventListener('error', (e) => {
  if (
    e.message &&
    (e.message.includes('ResizeObserver loop') ||
      e.message.includes('ResizeObserver loop limit exceeded'))
  ) {
    e.stopImmediatePropagation();
    return true;
  }
});

import React from 'react';
import * as Sentry from '@sentry/browser';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import store, { history } from './store';
import App from './App';
import './index.css';
import { HostAppProxyProvider } from './contexts/HostAppProxyContext';
import { AuthProvider } from './contexts/AuthContext';

if (process.env.NODE_ENV !== 'development') {
  Sentry.init({
    dsn: 'https://c9da01dabfb74414b74ed51935e6a3e9@sentry.io/1487794',
  });
}
const target = document.querySelector('#root');

render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <HostAppProxyProvider>
        <AuthProvider>
          <App />
        </AuthProvider>
      </HostAppProxyProvider>
    </ConnectedRouter>
  </Provider>,
  target
);

// Clean up any service worker registered by historical CRA builds.
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.ready.then((registration) => registration.unregister()).catch(() => {});
}
